export default __webpack_public_path__ + "static/media/logo-bayer-branco.212258a6.png";